import React from 'react'

export default function ProgressBar(props) {
  return (
    <div className="ProgressBar">
      <div className="outer">
        <div className="inner" style={{width: props.percentage + "%"}}></div>
      </div>
    </div>
  )
}
